import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";
import { updatedUser } from "../../../api/user";
import { EditUserSchema } from "../../../validations/UserValidation";

const EditUserModal = ({ modalForm, setModalForm, userData }) => {
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(EditUserSchema),
    defaultValues: {
      name: userData.name,
      email: userData.email,
      role: userData.role,
    },
  });

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      await updatedUser(data, userData.id);

      toast.success("User is updated successfully", {
        position: "top-center",
      });

      reset({
        name: "",
        email: "",
        role: "user",
      });
      userData?.setMutationCall();
      toggleForm();
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        position: "top-center",
      });
    } finally {
      setLoading(false);
    }
  };

  const toggleForm = () => setModalForm(!modalForm);

  useEffect(() => {
    reset({
      name: userData.name,
      email: userData.email,
      role: userData.role,
    });
  }, [modalForm]);

  return (
    <Modal isOpen={modalForm}>
      <ModalHeader
        toggle={toggleForm}
        close={
          <button className="close" onClick={toggleForm}>
            {/* <Icon name="cross" /> */}
          </button>
        }
      >
        Edit User
      </ModalHeader>
      <ModalBody>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-group">
            <label className="form-label" htmlFor="full-name">
              Name
            </label>
            <div className="form-control-wrap">
              <input
                type="text"
                className={`form-control ${errors.name ? "error" : ""}`}
                id="full-name"
                placeholder="Enter your name"
                {...register("name", {
                  setValueAs: (value) => value.trim(),
                })}
              />
              {errors.name && (
                <span className="custom-invalid">{errors.name.message}</span>
              )}
            </div>
          </div>
          <div className="form-group">
            <label className="form-label" htmlFor="email">
              Email
            </label>
            <div className="form-control-wrap">
              <input
                type="text"
                className={`form-control ${errors.email ? "error" : ""}`}
                id="email"
                placeholder="Enter your email"
                {...register("email", {
                  setValueAs: (value) => value.trim(),
                })}
              />
              {errors.email && (
                <span className="custom-invalid">{errors.email.message}</span>
              )}
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Role</label>
            <ul className="custom-control-group g-3 align-center">
              <li>
                <div className="custom-control custom-radio custom-control-pro no-control checked">
                  <input
                    type="radio"
                    className="custom-control-input"
                    {...register("role", {
                      setValueAs: (value) => value.trim(),
                    })}
                    value="user"
                    id="btnRadio1"
                  />
                  <label className="custom-control-label" htmlFor="btnRadio1">
                    User
                  </label>
                </div>
              </li>
              <li>
                <div className="custom-control custom-radio custom-control-pro no-control checked">
                  <input
                    type="radio"
                    className="custom-control-input"
                    {...register("role", {
                      setValueAs: (value) => value.trim(),
                    })}
                    value="admin"
                    id="btnRadio2"
                  />
                  <label className="custom-control-label" htmlFor="btnRadio2">
                    Admin
                  </label>
                </div>
              </li>
            </ul>
          </div>
          <Row className="justify-content-end mx-auto">
            <Col className="col-auto px-0">
              <div className="form-group">
                <div className="d-flex justify-content-end pt-5">
                  <Button
                    color="white"
                    size="lg"
                    onClick={toggleForm}
                    disabled={loading}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </Col>
            <Col className="col-auto px-0">
              <div className="form-group">
                <div className="d-flex justify-content-end pt-5">
                  <Button
                    color="primary"
                    type="submit"
                    size="lg"
                    disabled={loading}
                  >
                    {loading ? <Spinner color="white" size="sm" /> : "Update"}
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default EditUserModal;
